/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFolderDollar = createReactComponent("folder-dollar", "IconFolderDollar", [
  [
    "path",
    {
      d: "M13.5 19h-8.5a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v1.5",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5",
      key: "svg-1"
    }
  ],
  ["path", { d: "M19 21v1m0 -8v1", key: "svg-2" }]
]);

export { IconFolderDollar as default };
//# sourceMappingURL=IconFolderDollar.js.map
